import * as React from 'react';
import SelectSearchComponent from '../../../../../common/components/SelectSearchComponent';
import {
    GLOBAL,
    LOAN_APPLICATION_MX
} from '../../../../constants/LabelConstants';
import {
    ReferencesSectionProps,
    ReferencesSectionState,
} from '../../../../types/mx/turboCash/components';
import * as ValidateConstant from '../../../../constants/ValidateConstant';
import {INPUTS} from '../../../../constants/MX/WizardInputs';
import * as InputTextTypes from '../../../../../common/components/InputTextTypes';
import InputText from '../../../../../common/components/InputText';
import {COUNTRIES} from '../../../../constants/AppConstants';

class ReferencesSectionView extends React.Component<ReferencesSectionProps, ReferencesSectionState> {

    constructor(props) {
        super(props);

        this.state = {
            references: this.defaultReferences(this.props.otherReferences),
            ...this.errorsFields(),
            areReferencesRepeatedError: false
        };
    }

    defaultReferences = references => Array.from(Array(COUNTRIES.MX.totalReferences).keys(), (index) => {
        const defaultOtherReference = {
            completeName: '',
            cellphone: '',
            phone: '',
            address: '',
            extNumber: '',
            intNumber: '',
            postalCode: '',
            state: {
                id: '',
                value: '',
                payload: ''
            },
            city: {
                id: '',
                value: '',
                payload: ''
            },
            municipality: {
                id: '',
                value: '',
                payload: ''
            },
            colonies: [],
            selectedColony: {
                id: '',
                value: '',
                payload: ''
            }
        };
        return !!references[index] ?
            {
                ...references[index]
            } :
            defaultOtherReference;
    })

    errorsFields = () => {
        const errorsFields = {};
        for (let i = 0; i < 3 ; i += 1) {
            errorsFields[`completeName${i}Error`] = this.props.otherReferences[i] &&
            this.props.otherReferences[i].completeName ? null : ValidateConstant.ERROR_REQUIRED;
            errorsFields[`cellphone${i}Error`] = this.props.otherReferences[i] &&
            this.props.otherReferences[i].cellphone ?
                this.props.otherReferences[i].cellphone.length === 10 ?
                    null : ValidateConstant.ERROR_MIN_LENGTH(10)
                : ValidateConstant.ERROR_REQUIRED;
            errorsFields[`phone${i}Error`] = this.props.otherReferences[i] &&
            this.props.otherReferences[i].phone ?
                this.props.otherReferences[i].phone.length === 10 ?
                    null : ValidateConstant.ERROR_MIN_LENGTH(10)
                : ValidateConstant.ERROR_REQUIRED;
            errorsFields[`address${i}Error`] = this.props.otherReferences[i] &&
            this.props.otherReferences[i].address ? null : ValidateConstant.ERROR_REQUIRED;
            errorsFields[`extNumber${i}Error`] = this.props.otherReferences[i] &&
            this.props.otherReferences[i].extNumber ? null : ValidateConstant.ERROR_REQUIRED;
            errorsFields[`postalCode${i}Error`] = this.props.otherReferences[i] &&
            this.props.otherReferences[i].postalCode ? null : ValidateConstant.ERROR_REQUIRED;
            errorsFields[`state${i}Error`] = this.props.otherReferences[i] &&
            this.props.otherReferences[i].state && this.props.otherReferences[i].state.value ?
                null : ValidateConstant.ERROR_REQUIRED;
            errorsFields[`municipality${i}Error`] = this.props.otherReferences[i] &&
            this.props.otherReferences[i].municipality && this.props.otherReferences[i].municipality.value ?
                null : ValidateConstant.ERROR_REQUIRED;
            errorsFields[`selectedColony${i}Error`] = this.props.otherReferences[i] &&
            this.props.otherReferences[i].selectedColony && this.props.otherReferences[i].selectedColony.value ?
                null : ValidateConstant.ERROR_REQUIRED;
        }
        return errorsFields;
    }

    componentDidUpdate(prevProps, prevState): void {
        const {otherReferences} = this.props;
        const {otherReferences: otherReferencesprevProps} = prevProps;

        const newReferenceDataArray = this.defaultReferences(this.props.otherReferences);
        otherReferences !== otherReferencesprevProps && this.setState({
            references: newReferenceDataArray,
            ...this.errorsFields()
        });
    }

    /* tslint:disable */
    UNSAFE_componentWillUpdate(nextProps, nextState, nextContext: any): void {
        const {dataPostalCode, otherReferences} = this.props;
        const {dataPostalCode: dataPostalCodeNextProps} = nextProps;

        const dataPostalCodeNextPropsOrDefault = dataPostalCodeNextProps || {
            index: 0,
            data: {
                state: {
                    id: '',
                    value: ''
                },
                city: {
                    id: '',
                    value: ''
                },
                municipality: {
                    id: '',
                    value: ''
                },
                colonies: [],
                selectedColony: {
                    id: '',
                    value: ''
                }
            }
        };

        const indexReference = dataPostalCodeNextPropsOrDefault.index;
        const nextData = dataPostalCodeNextPropsOrDefault.data;
        const newReferenceDataArray = this.defaultReferences(otherReferences);
        newReferenceDataArray[indexReference] = {...otherReferences[indexReference], ...nextData};

        dataPostalCode !== dataPostalCodeNextProps && this.setState({
            references: newReferenceDataArray,
            ...this.errorsFields()
        }, () => {
            this.props.onChangeOtherReferences(newReferenceDataArray);
        });
    }

    onChangeInput = (value, error, id, index, callBack = null) => {
        callBack && !!!error && this.props[callBack](index, value, error);

        const newReferenceDataArray = this.defaultReferences(this.props.otherReferences);
        newReferenceDataArray[index] = {...this.props.otherReferences[index], [id]: value};

        this.setState({references: newReferenceDataArray});
        this.props.onChangeOtherReferences(newReferenceDataArray);

        // @ts-ignore Todo: @mono Refactorizar typescripts
        this.setState({[`${id}${index}Error`]: error}, () => {
            this.validateReferences();
        });
    }

    renderReference(index, label) {
        if (this.state.references[index]) {
            return (
                <div className="row">
                    <div className="col-12">
                        <div className="header-bar mb-3">{label}</div>
                        <div className="row">
                            <div className="col-lg-4 pr-4">
                                <InputText id={INPUTS.COMPLETE_NAME} label={LOAN_APPLICATION_MX.COMPLETE_NAME}
                                           required
                                           hasError={this.props.showErrors}
                                           labelError={this.state[`${INPUTS.COMPLETE_NAME}${index}Error`]}
                                           value={this.state.references[index].completeName}
                                           onChange={(value, error) =>
                                               this.onChangeInput(value, error, 'completeName', index)}/>
                            </div>
                            <div className="col-lg-4 pr-4">
                                <InputText id={INPUTS.CELLPHONE} label={GLOBAL.CELLPHONE}
                                           required
                                           hasError={this.props.showErrors}
                                           labelError={this.state[`${INPUTS.CELLPHONE}${index}Error`]}
                                           maxLength={10}
                                           minLength={10}
                                           type={InputTextTypes.NUMBER}
                                           value={this.state.references[index].cellphone}
                                           onChange={(value, error) =>
                                               this.onChangeInput(value, error, 'cellphone', index)}/>
                            </div>
                            <div className="col-lg-4 pr-4">
                                <InputText id={INPUTS.PHONE} label={GLOBAL.PHONE}
                                           required
                                           hasError={this.props.showErrors}
                                           labelError={this.state[`${INPUTS.PHONE}${index}Error`]}
                                           maxLength={10}
                                           minLength={10}
                                           type={InputTextTypes.NUMBER}
                                           value={this.state.references[index].phone}
                                           onChange={(value, error) =>
                                               this.onChangeInput(value, error, 'phone', index)}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 pr-4">
                                <InputText id={INPUTS.EMPLOYMENT_ADDRESS} label={LOAN_APPLICATION_MX.EMPLOYMENT_ADDRESS}
                                           required
                                           hasError={this.props.showErrors}
                                           labelError={this.state[`${INPUTS.ADDRESS}${index}Error`]}
                                           value={this.state.references[index].address}
                                           onChange={(value, error) =>
                                               this.onChangeInput(value, error, 'address', index)}/>
                            </div>
                            <div className="col-lg-4 pr-4">
                                <InputText label={LOAN_APPLICATION_MX.EMPLOYMENT_EXTERNAL_NUMBER}
                                           id={INPUTS.EMPLOYMENT_EXTERNAL_NUMBER}
                                           required
                                           hasError={this.props.showErrors}
                                           labelError={this.state[`${INPUTS.EXT_NUMBER}${index}Error`]}
                                           maxLength={20}
                                           value={this.state.references[index].extNumber}
                                           onChange={(value, error) =>
                                               this.onChangeInput(value, error, 'extNumber', index)}/>
                            </div>
                            <div className="col-lg-4 pr-4">
                                <InputText label={LOAN_APPLICATION_MX.EMPLOYMENT_INTERNAL_NUMBER}
                                           id={INPUTS.EMPLOYMENT_INTERNAL_NUMBER}
                                           hasError={this.props.showErrors}
                                           labelError={this.state[`${INPUTS.INT_NUMBER}${index}Error`]}
                                           maxLength={20}
                                           value={this.state.references[index].intNumber}
                                           onChange={(value, error) =>
                                               this.onChangeInput(value, error, 'intNumber', index)}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 pr-4">
                                <InputText label={LOAN_APPLICATION_MX.EMPLOYMENT_POSTAL_CODE}
                                           id={INPUTS.EMPLOYMENT_POSTAL_CODE}
                                           value={this.state.references[index].postalCode}
                                           maxLength={5}
                                           minLength={5}
                                           required
                                           hasError={this.props.showErrors}
                                           labelError={this.state[`${INPUTS.POSTAL_CODE}${index}Error`]}
                                           type={InputTextTypes.NUMBER}
                                           onChange={(value, error) =>
                                               this.onChangeInput(
                                                   value, error, 'postalCode', index,
                                                   'onChangePostalCodeReference'
                                               )}/>
                            </div>
                            <div className="col-lg-4 pr-4">
                                <InputText label={LOAN_APPLICATION_MX.EMPLOYMENT_STATE}
                                           id={INPUTS.STATE}
                                           required
                                           hasError={this.props.showErrors}
                                           labelError={this.state[`${INPUTS.STATE}${index}Error`]}
                                           value={this.state.references[index].state &&
                                           this.state.references[index].state.value}/>
                            </div>
                            <div className="col-lg-4 pr-4">
                                <InputText label={LOAN_APPLICATION_MX.EMPLOYMENT_CITY}
                                           id={INPUTS.CITY}
                                           hasError={this.props.showErrors}
                                           labelError={this.state[`${INPUTS.CITY}${index}Error`]}
                                           value={this.state.references[index].city &&
                                           this.state.references[index].city.value}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 pr-4">
                                <InputText label={LOAN_APPLICATION_MX.EMPLOYMENT_MUNICIPALITY}
                                           id={INPUTS.MUNICIPALITY}
                                           required
                                           hasError={this.props.showErrors}
                                           labelError={this.state[`${INPUTS.MUNICIPALITY}${index}Error`]}
                                           value={this.state.references[index].municipality &&
                                           this.state.references[index].municipality.value}/>
                            </div>
                            <div className="col-lg-4 pr-4">
                                <SelectSearchComponent label={LOAN_APPLICATION_MX.EMPLOYMENT_COLONY}
                                                       id={INPUTS.SELECTED_COLONY}
                                                       required
                                                       hasError={this.props.showErrors}
                                                       placeholder={GLOBAL.SELECT}
                                                       labelError={this.state[`${INPUTS.SELECTED_COLONY}${index}Error`]}
                                                       value={this.state.references[index].selectedColony &&
                                                       this.state.references[index].selectedColony}
                                                       data={this.state.references[index].colonies &&
                                                       this.state.references[index].colonies}
                                                       onChange={(value, error) => this.onChangeInput(
                                                           value, error, 'selectedColony', index
                                                       )}/>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }

    areReferencesDifferent = () => {
        let areDifferent = true;
        const {otherReferences} = this.props;
        const refLength = otherReferences.length;

        for (let i = 0; i < refLength; i += 1) {
            for (let j = i + 1; j < refLength; j += 1) {
                const nameDiff = otherReferences[i].completeName === otherReferences[j].completeName;
                const phoneDiff = otherReferences[i].phone === otherReferences[j].phone;
                const cellPhoneDiff = otherReferences[i].cellphone === otherReferences[j].cellphone;
                if (nameDiff || phoneDiff || cellPhoneDiff) {
                    areDifferent = false;
                }
            }
        }
        return areDifferent;
    }

    allFieldsAreValid = () => {

        const refLength = COUNTRIES.MX.totalReferences;

        let areValid = true;

        for (let i = 0; i < refLength; i += 1) {
            areValid = this.state[`completeName${i}Error`] == null &&
                this.state[`phone${i}Error`] == null &&
                this.state[`cellphone${i}Error`] == null;
            if (!areValid) {
                break;
            }
        }

        return areValid;
    }

    validateReferences = () => {
        const areRefDifferent = this.areReferencesDifferent();
        const allFieldsAreValid = this.allFieldsAreValid();
        if (areRefDifferent && allFieldsAreValid) {
            this.setState({
                areReferencesRepeatedError: false
            });
        } else {
            this.setState({
                areReferencesRepeatedError: !areRefDifferent
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.renderReference(0, LOAN_APPLICATION_MX.REFERENCE_1)}
                {this.renderReference(1, LOAN_APPLICATION_MX.REFERENCE_2)}
                {this.renderReference(2, LOAN_APPLICATION_MX.REFERENCE_3)}

                {this.state.areReferencesRepeatedError &&
                <div className="row justify-content-end">
                    <div className="col form-text is-invalid py-3">
                        {ValidateConstant.ERROR_REPEATED_REFERENCE}
                    </div>
                </div>}
            </React.Fragment>
        );
    }
}

export default ReferencesSectionView;